export const WA_LOG_DETAILS_TEXT = {
	reason: 'Reason:',
	breakdownReason: 'Breakdown reason:',
};
